module.exports = __webpack_public_path__ + "img/i_select_s.c712a7d7.svg";